module.exports = __webpack_public_path__ + "img/img_3.156512a2.png";